import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import { merge } from "lodash-es";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

interface RoutedButtonProps {
  path: string;
  buttonColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
  buttonStyle?: React.CSSProperties;
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  variant?: "text" | "outlined" | "contained";
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  onClick?: () => void;
}

const RoutedButton = ({
  path,
  buttonColor,
  buttonStyle,
  children,
  size,
  variant,
  endIcon,
  startIcon,
  onClick,
}: RoutedButtonProps) => {
  const style = merge(buttonStyle ?? {}, getOverrideColor(buttonColor, variant));
  return (
    <Link component={RouterLink} to={path}>
      <Button
        color={buttonColor}
        style={style}
        size={size ?? "medium"}
        variant={variant ?? "contained"}
        endIcon={endIcon}
        startIcon={startIcon}
        onClick={onClick}
      >
        {children}
      </Button>
    </Link>
  );
};

const getOverrideColor = (
  buttonColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning",
  variant?: "text" | "outlined" | "contained"
) => {
  // if the color is inherit and variant is text/outlined
  // the text color should be black (it defaults to orange because of the link)

  if (buttonColor === "inherit") {
    if (variant === "text" || variant === "outlined") {
      return { color: "black" };
    }
  }
  return {};
};

export default RoutedButton;
